export default __webpack_public_path__ + "static/media/2.048e132a.png";